
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/home",
      function () {
        return require("private-next-pages/elearning/home.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/home"])
      });
    }
  